module.exports = function (Component) { Component.options.__i18n = '{"en":{"button_settings_title":"Settings","button_screen_share_title":"Share screen"},"de":{"button_settings_title":"Settings","button_screen_share_title":"Share screen"}}' }


//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/yaml-loader!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/Local.vue
// module id = 144
// module chunks = 1